import { render, staticRenderFns } from "./public_detail.vue?vue&type=template&id=7a3a3655&scoped=true"
import script from "./public_detail.vue?vue&type=script&lang=js"
export * from "./public_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3a3655",
  null
  
)

export default component.exports